import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '../../util';
import { Subscription } from 'rxjs';

import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { SubsidiaryService } from '../../services/subsidiary.service';
import { CustomerSupplierTypeService } from '../../services/customer-supplier-type.service';

@Component({
		selector: 'app-display-customer',
		templateUrl: './display-customer.component.html',
		styleUrls: ['./display-customer.component.css', '../../app.component.css']
})

export class DisplayCustomerComponent implements OnInit {

	customer: any = [];
	customerSub: Subscription;
	subsidiarySub: Subscription;
	customerSuplierTypeSub: Subscription;
	routeSub: Subscription;

	id: string;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private customerSupplierService: CustomerSupplierService,
		private subsidiaryService: SubsidiaryService,
		private customerSupplierTypeService: CustomerSupplierTypeService
	) {
	this.routeSub = this.activatedRoute.params.subscribe(parameters => {
		this.id = parameters['id'];
		this.router.navigate([`vw_customer/${this.id}/addresses`]);

			this.customerSub = this.customerSupplierService.getCustomerSupplier(this.id)
				.subscribe(customerObj => {
					this.subsidiarySub = this.subsidiaryService.getSubsidiary(customerObj.subsidiaryId)
						.subscribe(subsidiaryObj => {
							this.customerSuplierTypeSub = this.customerSupplierTypeService.getCustomerSupplierType(customerObj.typeId)
								.subscribe(typeObj => {
									this.customer = customerObj;

									if (this.customer.clientSince) {
										this.customer.clientSince = Utils.convertDatefromStringtoISOString(this.customer.clientSince);
									}

									this.customer.subsidiaryName = subsidiaryObj.name;
									this.customer.typeName = typeObj.name;
								});
						});
				});
		});
	}

	ngOnInit() {

	}
	ngOnDestroy() {
		this.subsidiarySub.unsubscribe();
		this.customerSub.unsubscribe();
		this.customerSuplierTypeSub.unsubscribe();
		this.routeSub.unsubscribe();
	}

}
